import { createReducer } from '../../utils/createReducer';
import { BehaviorState } from '../types';
import {
  SET_SHOW_SENDER_COMPONENT,
  TOGGLE_CHAT,
  TOGGLE_INPUT_DISABLED,
  TOGGLE_MESSAGE_LOADER,
  TOGGLE_SEND_DISABLED
} from '../actions/types';

const initialState = {
  showChat: false,
  disabledInput: false,
  disabledSend: false,
  messageLoader: false,
  messageFrom: '',
  messageType: ''
};

const behaviorReducer = {
  [TOGGLE_CHAT]: (state) => ({ ...state, showChat: !state.showChat }),

  [TOGGLE_INPUT_DISABLED]: (state) => ({ ...state, disabledInput: !state.disabledInput }),

  [TOGGLE_SEND_DISABLED]: (state, { cond }) => ({ ...state, disabledSend: cond }),

  [TOGGLE_MESSAGE_LOADER]: (state, { payload }) => {
    payload = payload || {};
    return {
      ...state,
      messageLoader: payload.messageLoader || false,
      messageFrom: payload.messageFrom || 'flow',
      messageType: payload.messageType || 'Typing'
    };
  }
};

export default function behavior(state = initialState, action) {
  return createReducer(behaviorReducer, state, action);
}
